import { Input } from '@aqarmap/aqarmap-ui';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { CustomFieldsType, ListingDetailsType } from '~addListing/types';
import { addListingDetailsType } from '~addListing/types';
import { useFormContext } from 'react-hook-form';
import { handleAttributeChange } from '~addListing/utils/handleAttributeChange';

const Floor = ({
  listing,
  customFieldsData,
  errorAttributeIds,
  setErrorAttributeIds,
}: {
  listing: ListingDetailsType;
  customFieldsData: { attributes: CustomFieldsType[] };
  errorAttributeIds: number[];
  setErrorAttributeIds: React.Dispatch<React.SetStateAction<number[]>>;
}) => {
  const floorKey = 'floor';
  const { t } = useTranslation('app');
  const listingPropertyTypeId = listing?.property_type.id;
  const floorData = customFieldsData.attributes?.find(
    (field: CustomFieldsType) => field.name === floorKey,
  );
  const floorDataId = Number(floorData?.id);
  const isError = errorAttributeIds.includes(floorDataId);

  const renderFloor = Object.values(
    floorData?.virtualPropertyTypesIds || {},
  ).includes(listingPropertyTypeId);

  const { setValue, getValues } = useFormContext<addListingDetailsType>();
  const defaultFloorValue =
    listing?.attributes.find((att) => att.custom_field.id === floorDataId)
      ?.value || 0;

  if (!renderFloor) return null;

  useEffect(() => {
    setValue(
      'attributes',
      handleAttributeChange(
        getValues('attributes'),
        floorDataId,
        defaultFloorValue,
      ),
    );
  }, [isError]);

  return (
    <Input
      label={{
        text: t('floor'),
        className: 'text-title_4 text-black',
      }}
      field={{
        placeholder: t('floorPlaceholder'),
        className:
          'text-gray__dark_2 text-gray__dark_2 placeholder:text-gray__dark_1 [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none [&::-moz-appearance:textfield]',
        type: 'number',
        defaultValue: defaultFloorValue !== 0 ? defaultFloorValue : '',
        onChange: (e) => {
          const value = Number(e.target.value);
          if (value >= 0)
            handleAttributeChange(getValues('attributes'), floorDataId, value);
          else handleAttributeChange(getValues('attributes'), floorDataId, 0);
        },
        min: 0,
        onFocus: () =>
          setErrorAttributeIds((prev) =>
            prev.filter((id) => id !== floorDataId),
          ),
        onWheel: (e) => (e.target as HTMLInputElement).blur(),
      }}
      error={isError ? t('floorError') : ''}
    />
  );
};

export default Floor;
